import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useStyles } from "./indexStyles";
import { withStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";
import { renderLogoProperty } from "../../helpers/lead";
import { getStorageItem } from "../../helpers/utils";
import { DEFAULT_PARTNER_CODE, SLUG_OPEN } from "../../constants";

const StyledVideo = styled("video")(({ theme }) => ({
  height: "570px !important",
  // position: "relative",
}));

function JourneyVideo({
  classes: {
    avivaLogo,
    containerButton,
    contentScroller,
    formGroup,
    logo,
    bgColorDark,
    headerBox,
    headerBoxContainer,
    headerText,
  },
  onClose,
  modal,
  modalKey = SLUG_OPEN,
}) {
  const videoUrl = `${process.env.REACT_APP_FOLDER_NAME}/video/${
    getStorageItem("partner") ?? "default"
  }`;
  const options = {
    language: [
      { title: "English", value: "english" },
      { title: "Hindi", value: "hindi" },
      { title: "Marathi", value: "marathi" },
    ],
    video: {
      english: `${videoUrl}/english/demo.mp4`,
      hindi: `${videoUrl}/hindi/demo.mp4`,
      marathi: `${videoUrl}/marathi/demo.mp4`,
    },
  };
  const videoRef = useRef(null);
  const [form, setForm] = useState({
    language:
      getStorageItem("partnerCode") === DEFAULT_PARTNER_CODE
        ? "marathi"
        : "hindi",
  });

  useEffect(() => {
    // Auto-play when the component mounts
    if (videoRef.current) {
      videoRef.current.play().catch((error) => {
        console.error("Autoplay failed:", error);
      });
    }
  }, []);

  const handleChange = (event) =>
    setForm({ ...form, [event.target.name]: event.target.value });

  return (
    <Dialog
      onClose={(event, reason) => onClose(event, reason, modalKey)}
      aria-labelledby="simple-dialog-title"
      open={modal.open}
      maxWidth={"lg"}
      fullScreen={true}
      fullWidth={true}
    >
      <Box className={headerBoxContainer}>
        <Box className={`${headerBox} ${bgColorDark}`}>
          <Box className={headerText}>
            <Grid container>
              <Grid item xs={12}>
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <img
                    src={renderLogoProperty("name")}
                    className={
                      getStorageItem("partnerCode") === DEFAULT_PARTNER_CODE
                        ? logo
                        : avivaLogo
                    }
                    alt="Aviva India"
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>

      <Box m={1} mt={0}>
        <Box className={contentScroller}>
          <Box
            className={formGroup}
            mt={1}
            display="flex"
            justifyContent="center"
          >
            <StyledVideo
              ref={videoRef}
              controls
              muted
              src={options.video[form.language]}
              type="video/mp4"
            />
          </Box>
        </Box>
        <Box
          className={containerButton}
          justifyContent="center"
          alignContent="center"
        >
          <Box
            mt={1}
            className={formGroup}
            display={"flex"}
            justifyContent={"center"}
          >
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name="language"
                sx={{ flexDirection: "row" }}
                value={form.language}
                onChange={handleChange}
              >
                <FormControlLabel
                  value="english"
                  control={<Radio />}
                  label="English"
                />
                <FormControlLabel
                  value="hindi"
                  control={<Radio />}
                  label="Hindi"
                />
                {getStorageItem("partnerCode") === DEFAULT_PARTNER_CODE && (
                  <FormControlLabel
                    value="marathi"
                    control={<Radio />}
                    label="Marathi"
                  />
                )}
              </RadioGroup>
            </FormControl>
          </Box>
          <Button
            type={"button"}
            variant={"contained"}
            color={"primary"}
            size={"small"}
            onClick={(event, reason) => onClose(event, reason, modalKey)}
            fullWidth
          >
            Close
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}

export default withStyles(useStyles, { withTheme: true })(JourneyVideo);
